import React, {Fragment} from 'react';
import AudioManager from "../../managers/AudioManager";
import './ContentBlock.css'
import {connect} from "react-redux";


class Track extends React.Component {

    render() {
        const {track, subTracks = [], playingId, selectedLanguage, object} = this.props;

        const playingInside = playingId ? [track.mediaId, ...subTracks.map(it => it.mediaId)].includes(playingId) : false;
        const playingMedia = playingInside ? [track, ...subTracks].find(it => it.mediaId === playingId) : null;
        // const playingIndex = [track, ...subTracks].findIndex(it => it.mediaId === playingId) + 1;
        // const nextSubMedia = [track, ...subTracks][playingIndex];

        const iconClass = playingInside
            ? "playButton fas fa-pause"
            : "playButton fas fa-play";

        if (selectedLanguage && selectedLanguage !== track.tags.Language && track.tags.Language !== 'independent' && !track.ignoreLang) return null;
        if (!track.isAllowedForWeb) return null;

        const mainDescription = (playingMedia ? playingMedia.getDescription : null) || track.getDescription || "No description";

        let additionalDescription = object && (object.description(track.language) || object.description(selectedLanguage));
        if (additionalDescription === mainDescription) additionalDescription = null;

        return (
            <Fragment>
                <div className="TrackItem"
                     onClick={(e) => {

                         console.log("GLOBAL START");
                         AudioManager.stop();
                         AudioManager.play(playingMedia || track);
                     }}>

                    <div className='TrackItemButton'>
                        <i className={iconClass}
                           onClick={(e) => {
                               e.stopPropagation();
                               AudioManager.play(playingMedia || track)
                           }}/>
                    </div>

                    <div className={playingInside ? 'TrackItemDescriptionPlaying' : 'TrackItemDescription'}>
                        {mainDescription}

                        {
                            additionalDescription &&
                                <small className='grayColored'>
                                    <br/>
                                    {additionalDescription}
                                </small>
                        }
                    </div>

                    <div className="trackInfo" onClick={(e) => {
                        e.stopPropagation();
                        AudioManager.stop();
                        AudioManager._playNextAudio()
                    }}>
                        {
                            /*playingInside
                                ? <span> {playingIndex}/{subTracks.length + 1} <i
                                    className="fad fa-fast-forward"/> </span>
                                : null*/
                        }
                    </div>
                </div>

                {
                    /*playingMedia && playingMedia.textData &&
                    <div className="trackText">
                        { playingMedia.textData }
                    </div>*/
                }
            </Fragment>
        )
    }

}


const mapStateToProps = ({object}) => ({object});
export default connect(mapStateToProps)(Track);